import React from "react"

import { Value } from "@features/Price/Features/FeatureValue"
import { Available, Disabled, WithTooltip } from "@features/Price/Features/FeatureParts"

import * as styles from "./style.module.scss"

interface OneFeatureProps {
  name?: string
  description?: string
  more?: string
  options?: Array<string | number | undefined>
  // Индексы колонок для показа (публичная — по команде, v424 — по тарифам страницы)
  indices: number[]
}

// Единый leaf-рендерер строки фичи для обоих движков (public /price/ и *-v424).
const OneFeature = ({ name, description, more, options = [], indices }: OneFeatureProps) => {
  const rowLayoutClassName = indices.length === 1 ? styles.featureRowTwoColumns : styles.featureRowFourColumns

  return (
    <div className={styles.featureWrapper}>
      <div className={styles.featureInfoMobile}>
        {description ? <WithTooltip name={name} description={description} /> : name}
        {more && <div>{more}</div>}
      </div>
      <div className={`${styles.featureRow} ${rowLayoutClassName}`}>
        <div className={styles.featureInfo}>
          {description ? <WithTooltip name={name} description={description} /> : name}
          {more && <div>{more}</div>}
        </div>

        {indices.map((index) => {
          const option = options[index]

          return (
            <div key={index} className={styles.featureOption}>
              {option === 1 ? <Available /> : option === 0 || option === undefined ? <Disabled /> : <Value value={option} />}
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default OneFeature
